import * as React from "react";
import type { SVGProps } from "react";
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.72 6H21.6M8.72 12.48H21.6M8.72 18.96H21.6M3.6 6v.013m0 6.467v.013m0 6.467v.013"
    />
  </svg>
);
export default SvgList;
